/*-----------------------------------------------------------------
- Subscription trans
-----------------------------------------------------------------*/
export default {

    subscription: 'اشتراک',

};
